import {Component, Output, ViewChild, EventEmitter} from '@angular/core';
import {Http} from '@angular/http';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import {ModalDirective} from 'ng2-bootstrap/modal';
import {ToasterService} from 'angular2-toaster/angular2-toaster';
import {ProvincesService} from "../../../models/provinces/provinces.service";
import {ResponseService} from "../../../models/response/response.service";
import {LeadUpdateModel, LeadsModel} from "../../../models/leads/leads.model";
import {LeadsService} from "../../../models/leads/leads.service";
import {ProvincesModel} from "../../../models/provinces/provinces.model";
import {UsersService} from "../../../models/users/users.service";

import {phoneFormatter} from "../../../helpers/phone-format";

@Component({
    selector: 'lead-edit',
    templateUrl: 'lead-edit.template.html',
    exportAs: 'leadEdit'
})
export class LeadEditComponent {
    phoneFormatter = phoneFormatter;
    public leadForm: FormGroup;

    public provinceList = <ProvincesModel[]> [];


    private model: LeadUpdateModel = LeadsService.getEmptyModel();
    private Model: LeadsService;
    private leadData: LeadsModel;

    @ViewChild('leadEditModal') public leadEditModal: ModalDirective;
    @Output() onEdit: EventEmitter<any> = new EventEmitter<any>();

    public openerList: Array<any> = [];
    public fundingSpecialist: Array<any> = [];
    public leadSumList: Array<any> = [];


    // ===========================================================
    // Init
    // ===========================================================

    constructor(
        private fb: FormBuilder,
        private http: Http,
        private toasterService: ToasterService,
        public provincesService: ProvincesService,
        private usersService: UsersService,
    ) {
        this.Model = new LeadsService(this.http);
    }

    ngOnInit() {
        this.createForm();

        this.provincesService.getList()
           .subscribe((res) => {
               this.provinceList = res.data;
           });

        this.loadOpenerList();
        this.loadUserFSList();
    }

    _telephoneHelperField: any;


    // ===========================================================
    // Load Data
    // ===========================================================



    // ===========================================================
    // Actions
    // ===========================================================

    public hide() {
        this.leadForm.reset(LeadsService.getEmptyModel());
        this.leadEditModal.hide();
    }

    public show(lead: LeadsModel) {
        this.leadData = lead;

        this.model.company_name = this.leadData.company_name;
        this.model.address = this.leadData.address;
        this.model.city = this.leadData.city;
        this.model.postal_code = this.leadData.postal_code;
        this.model.contact = this.leadData.contact;
        this.model.telephone = phoneFormatter.getCAXFormat(this.leadData.telephone, true);
        this._telephoneHelperField = phoneFormatter.getOnlyNumbes(this.leadData.telephone);

        this.model.province_id = this.leadData.province.id;
        this.model.new_opener_id = null;


        this.leadForm .patchValue(this.model, {onlySelf: true});
        this.leadEditModal.show();
    }

    public save(form: LeadUpdateModel, isValid: boolean)
    {
        if (!isValid) {
            return false;
        }

        this.leadForm.disable();

        let form_modified = Object.assign({}, form);
        form_modified.telephone = this._telephoneHelperField;

        this.Model.edit(this.leadData.id, form_modified)
            .subscribe(
                () => {
                    this.leadForm.enable();
                    this.hide();

                    this.toasterService.pop('success', 'Success', 'Client was updated');

                    this.onEdit.emit();
                },
                (error) => {
                    this.leadForm.enable();
                    this.leadForm.controls = ResponseService.parseResponseError(this.leadForm.controls, error);
                    this.leadForm.updateValueAndValidity();
                });
    }

    // ===========================================================
    // Functions
    // ===========================================================

    private createForm() {
        // noinspection TypeScriptValidateTypes
        this.leadForm = this.fb.group({
            company_name: new FormControl(this.model.company_name, [Validators.required]),
            address: new FormControl(this.model.address, [Validators.required]),
            city: new FormControl(this.model.city, [Validators.required]),
            province_id: new FormControl(this.model.province_id, [Validators.required]),
            postal_code: new FormControl(this.model.postal_code, [Validators.required]),
            telephone: new FormControl(this.model.telephone, [Validators.required]),
            contact: new FormControl(this.model.contact, [Validators.required]),
            new_opener_id: new FormControl(this.model.new_opener_id)
        });
    }

    private loadOpenerList() {
        this.usersService.getOpener()
            .subscribe(
                (res) => {
                    this.openerList = res.data;
                    this.leadSumList = this.openerList.concat(this.fundingSpecialist);

                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                    console.log(errorData.message);
                });

    }

    private loadUserFSList() {

        this.usersService.getFS()
            .subscribe(
                (res) => {
                    this.fundingSpecialist = res.data;
                    this.leadSumList = this.openerList.concat(this.fundingSpecialist);
                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                });
    }
}


// WEBPACK FOOTER //
// ./src/app/views/leads/edit/lead-edit.component.ts